export const NO_THANKS_OPTION = {
    productId: 'no',
    productName: 'No Thanks',
    displayName: 'No Thanks',
    noImage: 'noImage',
    productPriceDescription: {
        price: 0.00
    }
}

export const swissInsertsProductOsrs = ['CH1LTWEB', 'CUSTOM_PATCHWEB']
export const requiredToDisplayFeatureOsrs = ['INSERT03', 'INSERT05']